import React, { createContext } from "react";

export const UserContext = React.createContext({});
